/**
 * Absolute paths owned by the auth domain. Imported from navigations,
 * pages, and any consumer that needs to `<Link to={...} />` or
 * `navigate(...)` to an auth route.
 */
export const AUTH_ROUTES = {
	login: "/login",
	loginWithEmail: (email: string) => `/login?email=${encodeURIComponent(email)}` as const,
	inviteAcceptPattern: "/invite/:token",
	inviteAccept: (token: string) => `/invite/${token}` as const,
	oauthConsent: "/oauth/consent",
} as const;
